export enum TemplateAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    ADD_TEMPLATE_LIST = "ADD_TEMPLATE_LIST",
    UPDATE_TEMPLATE_LIST = "UPDATE_TEMPLATE_LIST",
    UPDATE_TEMPLATE_SEARCH_REQ = "UPDATE_TEMPLATE_SEARCH_REQ",
}